// extracted by mini-css-extract-plugin
export default {"headerIcon":"styles-module__headerIcon___kPCYU","documentsContainer":"styles-module__documentsContainer___wH8Ik"};